import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import { Link, RouteComponentProps } from "react-router-dom";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import HomeIcon from "@material-ui/icons/Home";
import clsx from "clsx";

const useStyles = makeStyles((_theme: Theme) => ({
  /* Styles applied to the root element. */
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const msg = defineMessages({
  contentBody: {
    id: "pageNotFound.content.body",
    description: "Text of the content body.",
    defaultMessage: "Page not found",
  },
  goBackHomeButtonLabel: {
    id: "pageNotFound.goBackHomeButton.label",
    description: "Label of the go back home button.",
    defaultMessage: "Go back home",
  },
});

export type PageNotFoundProps = RouteComponentProps &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

function PageNotFound(props: PageNotFoundProps) {
  const { className, history, location, match, staticContext, ...other } =
    props;
  const classes = useStyles();
  const rootClasses = React.useMemo(() => {
    return clsx(classes.root, className);
  }, [className, classes.root]);

  return (
    <div className={rootClasses} {...other}>
      <Typography variant="h1">404</Typography>
      <Typography gutterBottom>
        <FormattedMessage {...msg.contentBody} />
      </Typography>
      <Button
        color="primary"
        variant="contained"
        startIcon={<HomeIcon />}
        component={Link}
        to="/"
      >
        <FormattedMessage {...msg.goBackHomeButtonLabel} />
      </Button>
    </div>
  );
}

export default PageNotFound;
